module.exports = __webpack_public_path__ + "static/img/precise.5bda696.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/address/precise.jpg
// module id = z53O
// module chunks = 0